
document.querySelectorAll(".job-drop-area").forEach((dropArea) => {
    const fileInput = dropArea.querySelector("input[type='file']");
const formElement = dropArea.closest(".form-element");
const uploadedBox = formElement.querySelector(".file-uploaded");
const fileNameEl = uploadedBox.querySelector(".file-name");

// Prevent default drag behaviors
["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
    dropArea.addEventListener(eventName, (e) => {
    e.preventDefault();
e.stopPropagation();
});
});

// Highlight
["dragenter", "dragover"].forEach((eventName) => {
    dropArea.addEventListener(eventName, () =>
dropArea.classList.add("highlight")
);
});

["dragleave", "drop"].forEach((eventName) => {
    dropArea.addEventListener(eventName, () =>
dropArea.classList.remove("highlight")
);
});

// Click to open file dialog
dropArea.addEventListener("click", () => fileInput.click());

// Drop handler
dropArea.addEventListener("drop", (e) => {
    const files = e.dataTransfer.files;
assignFile(files);
});

// Manual selection
fileInput.addEventListener("change", (e) => {
    assignFile(e.target.files);
});

function assignFile(files) {
    if (!files || files.length === 0) return;

    const file = files[0];

    // Assign dropped file to real input
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);
    fileInput.files = dataTransfer.files;

    // Show UI
    fileNameEl.innerHTML = `<span class="icon icon-file"></span> ${file.name}`;
    uploadedBox.classList.remove("d-none");
}
});

